import { createContext, useContext, useEffect, useMemo, useState } from 'react';

interface AppContextProps {
  env: string;
  trackingId: string;
  setTrackingId: (trackingId: string) => void;
}

type AppProvidersProps = {
  children: React.ReactNode;
  envParam: string;
  trackingIdParam: string;
};

const AppContext = createContext<AppContextProps>({
  env: '',
  trackingId: '',
  setTrackingId: () => {},
});

export const AppProvider = ({
  children,
  envParam,
  trackingIdParam,
}: AppProvidersProps) => {
  const [env, setEnv] = useState(envParam);
  const [trackingId, setTrackingId] = useState(trackingIdParam);

  useEffect(() => {
    setEnv(envParam);
    setTrackingId(trackingIdParam);
  }, [envParam, trackingIdParam]);

  const value = useMemo(
    () => ({ env, trackingId, setTrackingId }),
    [env, trackingId, setTrackingId],
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
export const useAppContext = () => useContext(AppContext);

export default { useAppContext, AppProvider };
